export function level() {
    // 0 默认黑色背景
    // 1 墙
    // 2 地板
    // 3 箱子
    // 4 终点
    // 5 人

    return [
        [
            [0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
            [0, 0, 0, 1, 4, 1, 0, 0, 0, 0],
            [0, 0, 0, 1, 2, 1, 1, 1, 1, 0],
            [0, 1, 1, 1, 3, 2, 3, 4, 1, 0],
            [0, 1, 4, 2, 3, 5, 1, 1, 1, 0],
            [0, 1, 1, 1, 1, 3, 1, 0, 0, 0],
            [0, 0, 0, 0, 1, 4, 1, 0, 0, 0],
            [0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ],
        [
            [1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
            [1, 2, 2, 2, 1, 0, 0, 0, 0, 0],
            [1, 2, 3, 2, 1, 0, 1, 1, 1, 0],
            [1, 2, 3, 5, 1, 0, 1, 4, 1, 0],
            [1, 1, 1, 3, 1, 1, 1, 4, 1, 0],
            [0, 1, 1, 2, 2, 2, 2, 4, 1, 0],
            [0, 1, 2, 2, 2, 1, 2, 2, 1, 0],
            [0, 1, 2, 2, 2, 1, 1, 1, 1, 0],
            [0, 1, 1, 1, 1, 1, 0, 0, 0, 0]
        ],
        [
            [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
            [0, 1, 2, 2, 1, 1, 2, 2, 2, 1, 0],
            [0, 1, 2, 2, 2, 3, 2, 2, 2, 1, 0],
            [0, 1, 3, 2, 1, 1, 1, 2, 3, 1, 0],
            [0, 1, 2, 1, 4, 4, 4, 1, 2, 1, 0],
            [1, 1, 2, 1, 4, 4, 4, 1, 2, 1, 1],
            [1, 2, 3, 2, 2, 3, 2, 2, 3, 2, 1],
            [1, 2, 2, 2, 2, 2, 1, 2, 2, 5, 1],
            [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
        ],
        [
            [0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
            [0, 1, 1, 2, 2, 2, 1, 1, 0, 0],
            [0, 1, 2, 2, 3, 4, 4, 1, 1, 0],
            [1, 1, 3, 2, 1, 4, 3, 4, 1, 0],
            [1, 2, 2, 2, 1, 4, 4, 4, 1, 0],
            [1, 2, 3, 1, 1, 1, 3, 2, 1, 0],
            [1, 2, 2, 3, 2, 3, 2, 1, 1, 0],
            [1, 1, 5, 2, 2, 2, 2, 1, 0, 0],
            [0, 1, 1, 1, 1, 1, 1, 1, 0, 0]
        ]
    ];
}


// WEBPACK FOOTER //
// ./src/common/js/level.js